var _circle, _path, _path2, _path3, _path4, _line, _line2, _path5, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySearchFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 39H56.375V64.5C56.375 65.3284 55.7034 66 54.875 66H31.625V39Z",
    fill: "#9B8AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 39H31.625V66H19.625C18.7966 66 18.125 65.3284 18.125 64.5V39Z",
    fill: "#D9D6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 39H31.625L26.1815 48H12.5L18.125 39Z",
    fill: "#EAE8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5074 39H31.625L37.25 48H62.375L56.5074 39Z",
    fill: "#EAE8FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.125,
    y1: 59.25,
    x2: 41.375,
    y2: 59.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.125,
    y1: 62.25,
    x2: 41.375,
    y2: 62.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9885 37.7153L54.8845 35.6113L51.8613 38.6345L53.9641 40.7373C53.8683 41.7075 54.192 42.7113 54.9352 43.4544L63.2851 51.8044C64.6017 53.1209 66.7363 53.1209 68.0529 51.8044C69.3695 50.4878 69.3695 48.3531 68.0529 47.0366L59.703 38.6866C58.9605 37.9442 57.9579 37.6204 56.9885 37.7153Z",
    fill: "#344054"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.125,
    cy: 28.5,
    r: 10.875,
    fill: "#F9FAFB",
    stroke: "#98A2B3",
    strokeWidth: 5.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearchFolder);
export default __webpack_public_path__ + "static/media/EmptySearchFolder.2aa58517fded83ddc353e497eb0cc551.svg";
export { ForwardRef as ReactComponent };